import { ProductCategoryCreatePage } from "@/features/product-category/pages/ProductCategoryCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-category/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_category.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductCategoryCreatePage,
});
